<template>
  <div>
    <v-card v-for="question in orderedQuestions" :key="question.id" class="mb-2">
      <v-card-title class="headline">{{ question.pivot.sort_order }}. {{ question.text }}</v-card-title>
      <answer-colour-picker :question="question"></answer-colour-picker>
    </v-card>
  </div>
</template>

<script>
import _ from 'lodash';
import AnswerColourPicker from './AnswerColourPicker';

export default {
  components: { AnswerColourPicker },
  name: 'answers',
  props: ['questions'],
  computed: {
    orderedQuestions: function() {
      const questions = _.filter(this.questions, question => question.include_in_rag === true);
      return _.orderBy(questions, 'pivot.sort_order');
    }
  }
};
</script>

<style lang="scss" scoped></style>
